import {green} from '@mui/material/colors';

export const innerListStyle = {
  bgcolor: '#fdfcfc',
  boxShadow:
    'inset rgba(0, 0, 0, 0.2) 0px 1px 7px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
};

export const buttonStyle = {
  height: '40px',
  fontSize: '0.87rem',
  letterSpacing: '0',
  backgroundColor: green[500],
  textTransform: 'none',
  '&:hover': {
    backgroundColor: green[600],
  },
};
